export default __webpack_public_path__ + "static/media/xWin-logo.f04b641f.png";